<template>
	<div class="container__classes__cubagem">
		<div class="container__classes__cubagem_header">
			<p>Classe: {{ intervalo }}</p>
			<i
				class="fas fa-trash"
				@click="excluir(intervalo)"
			/>
		</div>
		<div class="container__classes__cubagem__quantidade">
			<label>Árvores:</label>
			<input
				type="number"
				:value="value"
				v-on="inputListeners"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		// Valor a se fazer o bind
		value: {
			type: Number,
		},
		// Classe e Frequencia
		intervalo: {
			type: String,
		},
		// Metodo para excluir card
		excluir: {
			type: Function,
		},
	},
	data() {
		return {
			debounceTimer: null,
		}
	},
	computed: {
		inputListeners: function () {
			var vm = this
			return Object.assign({}, this.$listeners, {
				/**
				 * Para funcionar o v-model com debounce
				 */
				input: function (event) {
					if (event.target) {
						clearTimeout(vm.debounceTimer)
						vm.debounceTimer = setTimeout(() => {
							vm.$emit('input', Number(event.target.value))
						}, 300)
					}
				},
			})
		},
	},
	beforeDestroy() {
		clearTimeout(this.debounceTimer)
	},
}
</script>

<style scoped>
.container__classes__cubagem {
	padding: 0.5rem;
	background: var(--color-background);
	border: 1px solid rgb(var(--color-primary));
	border-radius: 5px;
	font-size: 0.9rem;
	margin-bottom: 1rem;
	color: rgb(var(--color-primary));
	font-family: 'Open Sans', sans-serif;
	font-size: 0.75rem;
}

.container__classes__cubagem_header {
	display: flex;
	justify-content: space-between;
}

.container__classes__cubagem_header > p {
	font-weight: 600;
	margin-bottom: 0;
}

.container__classes__cubagem_header > i {
	cursor: pointer;
	color: var(--color-gray);
}

.container__classes__cubagem_header > i:hover {
	color: rgb(var(--color-primary));
}

.container__classes__cubagem__quantidade {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.container__classes__cubagem__quantidade > input {
	background-color: white;
	border: 1px solid rgb(var(--color-primary));
	border-radius: 5px;
	padding-left: 1rem;
	max-width: 5rem;
	font-size: 1rem;
}
</style>
